import { Typography } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as Minus } from '../../../Assets/Rectangle.svg';
import { ReactComponent as Plus } from '../../../Assets/plus.svg';
import { ReactComponent as BackButton } from '../../../Assets/sib/back_button.svg';

import { AppContext } from '../../../App';
import { EVENTCODES, pushEventToParent } from '../../../Utils/eventUtils';
import { ROUTES } from '../../../Utils/routes';
import { getAltJourney } from '../../../Utils/storageUtils';
import { altJourneyType } from '../../../Utils/types';
import './index.css';

const FAQ: React.FC<{ onBack?: () => void }> = ({ onBack }) => {
  const { currentRoute, setCurrentRoute, setPreviousRoute, setBackButtonHandler, previousRoute }: any = useContext(AppContext);

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    setPreviousRoute(currentRoute);
    setCurrentRoute(previousRoute || ROUTES.SIB_SPENDS);
  };

  useEffect(() => {
    if (onBack) return;
    console.log('[BackButtonHandler] registering handler FAQ', {});
    setBackButtonHandler(() => handleBack);
    return () => {
      console.log('[BackButtonHandler] FAQ cleanup: resetting to SIB Spends from SIB FAQ');
      setBackButtonHandler(() => () => {
        setPreviousRoute(currentRoute);
        setCurrentRoute(ROUTES.SIB_SPENDS);
      });
    };
  }, [onBack]);
  const [faqs, setFaqs] = useState([
    {
      question: 'What is an Account Aggregator?',
      answer:
        'Account Aggregator is an RBI regulated entity that allows you to securely share information from one regulated financial institution to another with user consent.',
      open: false,
    },
    {
      question: "Why can't I find my bank/bank account now?",
      answer:
        'Over 70 banks are live on the Account Aggregator network. If your Bank is not visible, it may not be a part of the Account Aggregator network. Please ensure all your bank accounts across different banks are linked to the same mobile number used for registration.',
      open: false,
    },
    {
      question: 'Who can access the data I share?',
      answer:
        'Only RBI-regulated financial institutions can store data based on user consent. No other entity, including the Account Aggregator, can read, access, or store this information. Data storage and usage follow RBI master directions based on the defined purpose code. For more details visit https://rbidocs.rbi.org.in/rdocs/notification/PDFs/MD46859213614C3046C1BF9B7CF563FF1346.PDF',
      open: false,
    },
    {
      question: 'How can I stop data sharing?',
      answer:
        'Open Account Summary → Select the bank account for which you want to revoke data-sharing consent → Scroll down and click on Stop Tracking.',
      open: false,
    },
    {
      question: 'Is it safe to connect my accounts?',
      answer:
        'Yes. Account linking and data sharing happen only after your explicit consent. Data is shared through regulated entities in the Account Aggregator ecosystem.',
      open: false,
    },
    {
      question: 'Can I link accounts from multiple banks?',
      answer:
        'Yes. You can link eligible accounts from multiple banks, as long as they are available on the Account Aggregator network and are linked to your registered mobile number.',
      open: false,
    },
    {
      question: 'How often is my account data refreshed?',
      answer:
        'Data refresh depends on your active consent and bank\'s availability. In most cases, the app fetches updated data periodically as well as when you trigger a refresh.',
      open: false,
    },
    {
      question: 'Why am I seeing no transactions or incomplete data?',
      answer:
        'This can happen if consent is pending or recently revoked, or the bank is temporarily unavailable. Please try again after some time or refresh your linked account.',
      open: false,
    },
    {
      question: 'Can I remove one linked account without removing all?',
      answer:
        'Yes. You can manage consent per linked account and stop tracking for specific accounts from the account details section.',
      open: false,
    },
  ]);

  const toggleFAQ = (index: any) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  const FAQ = (faq: any, index: number) => {
    return (
      <div
        className={'faq ' + (faq.open ? 'open' : '')}
        key={index}
        onClick={() => {
          pushEventToParent({ eventCode: EVENTCODES.FAQ_CLICKED });
          toggleFAQ(index);
        }}
      >
        <div className='faq-questionRoot'>
          <div className='faq-question fontFamilyHeader'>
            {index + 1}. {faq.question}
          </div>
          {!faq.open ? <Plus className='sibFaqIcon' /> : <Minus className='sibFaqIcon' />}
        </div>
        <div className='faq-answer'>
          {faq.answer}{' '}
          {faq.link ? (
            <a
              href={faq.link.href}
              target='_blank'
              rel='noopener noreferrer'
              onClick={(e) => e.stopPropagation()}
            >
              {faq.link.text}
            </a>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <div className='sibFaqPage'>
      <div className='sibFaqHeader'>
        <div className='sibFaqHeaderLeft'>
          <BackButton
            className='sibFaqBackButton'
            onClick={handleBack}
          />
          <Typography.Text className='sibFaqHeaderTitle'>FAQs</Typography.Text>
        </div>
      </div>

      <div className='sibFaqContentCard'>
        <Typography.Text
          className='fontFamilyHeader assetsTitle'
        >
          You’ve got questions?{' '}
          {getAltJourney() === altJourneyType.YESONLINE ? <></> : <br />}
          We’ve got answers
        </Typography.Text>

        <div className='yfaqs'>
          {faqs.map((faq, index) => FAQ(faq, index))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
